export * from './inline-row-form-component-config.interface';
